import React from "react";
import classnames from "classnames";
import { Form } from "react-bootstrap";
import { FiStar } from "react-icons/fi";
import { formatCurrency } from "utils/number";
import { DAILY } from "utils/timeHelper";

const modifierToAbbrvModifierMap: Record<string, string> = {
  [DAILY]: "daily",
  TWICE_PER_MONTH: "twice a month",
  WEEKLY: "weekly",
  EVERY_OTHER_WEEK: "every two weeks",
  MONTHLY: "monthly",
};
import "./Contributions.scss";

interface SelectContributionBoxProps {
  onSelect: (amount?: number) => void;
  setCustomAmount?: (amount: number) => void;
  isSelected?: boolean;
  isCustomAmount?: boolean;
  isRecommended?: boolean;
  amount: number;
  modifier: string;
  payperiod?: string;
  customAmountError?: string;
  customAmountDisplayValue?: string;
  contributionLimits: {
    min?: number;
    max?: number;
  };
}

// if the amount is 0 here, that means that amount` was undefined/null and was type coerced to `0` in the parent components
const SelectContributionBox = ({
  onSelect,
  isSelected,
  isCustomAmount,
  isRecommended,
  amount,
  modifier,
  customAmountError,
  setCustomAmount,
  contributionLimits,
}: SelectContributionBoxProps) => {
  const modifierDisplayVal = modifierToAbbrvModifierMap[modifier];
  return (
    <div
      className={classnames("select-contribution-box shadow", {
        selected: isSelected,
        recommended: isRecommended,
        custom: isCustomAmount,
        error: !!customAmountError,
      })}
      onClick={() => onSelect(amount)}
    >
      {!isCustomAmount && (
        <div className="contribution-amount-container">
          <span className="amount">{formatCurrency(amount)}</span>
          <span className="amount-modifier">{modifierDisplayVal}</span>
        </div>
      )}
      {isRecommended && (
        <div className="recommended-container">
          <FiStar size={12} color="#FFFFFF" /> Most popular
        </div>
      )}
      {isCustomAmount && (
        <div className="contribution-custom-amount-container">
          {!isSelected && (
            <span className="custom-amt-msg">Enter custom amount</span>
          )}
          {isSelected && (
            <>
              <span className="dollar">$</span>
              <Form.Control
                style={{
                  width: 105,
                  display: "inline-block",
                  marginRight: 8,
                  paddingLeft: "1rem",
                }}
                name="incomeLimitsRawValue"
                size="sm"
                placeholder={contributionLimits.min as unknown as string}
                value={(amount === 0 ? null : amount) as unknown as number}
                type="number"
                max={contributionLimits.max}
                min={contributionLimits.min}
                onChange={(e) => {
                  const amount = +e.target.value;
                  setCustomAmount?.(amount);
                }}
                isInvalid={!!customAmountError}
                isValid={(amount && !customAmountError) as boolean}
              />
              <span style={{ verticalAlign: "bottom" }}>
                {modifierDisplayVal}
              </span>
              <Form.Control.Feedback type="invalid">
                {customAmountError}
              </Form.Control.Feedback>
            </>
          )}
        </div>
      )}

      {isCustomAmount && isSelected && (
        <div className="description">
          <ul>
            <li>
              Minimum contribution is{" "}
              {formatCurrency(contributionLimits.min as number, 0)}
            </li>
            <li>
              Maximum contribution is{" "}
              {formatCurrency(contributionLimits.max as number, 0)}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default SelectContributionBox;
